// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { connectStorageEmulator, getStorage } from "firebase/storage";

// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration (env-first, fallback to prod)
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBCXrB-YjWPHFv1WOllluG_5gVuEORIndA",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "seo-phenix-firebase.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "seo-phenix-firebase",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "seo-phenix-firebase.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "55064176464",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:55064176464:web:8d7084c497f78addb62e55",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-3RL80JDHQ1",
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const functions = getFunctions(app);
const auth = getAuth(app);
const storage = getStorage(app);


if (process.env.REACT_APP_USE_EMULATORS === "true") {
  console.log("firebase connecting to emulators")
  connectAuthEmulator(auth, "http://localhost:9099")
  connectFirestoreEmulator(db, "localhost", 8080)
  connectFunctionsEmulator(functions, "localhost", 5001)
  connectStorageEmulator(storage, "localhost", 9199)
}
//const analytics = getAnalytics(app);

export {
  auth,
  db,
  functions,
  storage
}
